export const LAST_REGISTERED_EMAIL_KEY = "last.registered.email.local.storage.key";
